import axiosClient from "./axios-client/axiosClient.jsx";

class SwapAPI {
  getLockedRates(token) {
    const headers = {
      headers: { Authorization: `Bearer ${token}` },
    };
    return axiosClient.get("/portfolio/swap/convert_get_my_locked", headers);
  }

  convertEstimate(token, amount, fromCurrency, toCurrency, lockTime) {
    const headers = {
      headers: { Authorization: `Bearer ${token}` },
    };

    const requestBody = {
      amount: Number(amount),
      from_currency: fromCurrency,
      to_currency: toCurrency,
      desired_lock_time_in_secs: Number(lockTime),
    };

    return axiosClient.post(
      "/portfolio/swap/convert_estimate",
      requestBody,
      headers,
    );
  }

  reverseConvertEstimate(token, amount, fromCurrency, toCurrency, lockTime) {
    const headers = {
      headers: { Authorization: `Bearer ${token}` },
    };

    const requestBody = {
      amount_to_receive: Number(amount),
      from_currency: fromCurrency,
      to_currency: toCurrency,
      desired_lock_time_in_secs: Number(lockTime),
    };

    return axiosClient.post(
      "/portfolio/swap/convert_estimate_reverse",
      requestBody,
      headers,
    );
  }

  conversionLock(token, amount, fromCurrency, toCurrency, lockTime) {
    const headers = {
      headers: { Authorization: `Bearer ${token}` },
    };

    const requestBody = {
      amount: Number(amount),
      from_currency: fromCurrency,
      to_currency: toCurrency,
      desired_lock_time_in_secs: Number(lockTime),
    };

    return axiosClient.post(
      "/portfolio/swap/convert_lock",
      requestBody,
      headers,
    );
  }

  reverseConversionLock(token, amount, fromCurrency, toCurrency, lockTime) {
    const headers = {
      headers: { Authorization: `Bearer ${token}` },
    };

    const requestBody = {
      amount_to_receive: Number(amount),
      from_currency: fromCurrency,
      to_currency: toCurrency,
      desired_lock_time_in_secs: Number(lockTime),
    };

    return axiosClient.post(
      "/portfolio/swap/convert_lock_reverse",
      requestBody,
      headers,
    );
  }

  convertNow(token, amount, fromCurrency, toCurrency) {
    const headers = {
      headers: { Authorization: `Bearer ${token}` },
    };

    const requestBody = {
      amount: Number(amount),
      from_currency: fromCurrency,
      to_currency: toCurrency,
    };

    return axiosClient.post("/portfolio/swap/convert", requestBody, headers);
  }

  sendWithLockedRate(token, locked_rate_id, txhash) {
    const headers = {
      headers: { Authorization: `Bearer ${token}` },
    };

    const requestBody = {
      locked_rate_id: locked_rate_id,
      txhash: txhash,
    };

    return axiosClient.post(
      "/portfolio/swap/convert_execute",
      requestBody,
      headers,
    );
  }

  convertWithLockedRate(token, locked_rate_id) {
    const headers = {
      headers: { Authorization: `Bearer ${token}` },
    };

    const requestBody = {
      locked_rate_id: locked_rate_id,
    };

    return axiosClient.post(
      "/portfolio/swap/convert_with_estimate",
      requestBody,
      headers,
    );
  }

  cancelLockedRate(token, locked_rate_id) {
    const headers = {
      headers: { Authorization: `Bearer ${token}` },
    };

    const requestBody = {
      locked_rate_id: locked_rate_id,
    };

    return axiosClient.post(
      "/portfolio/swap/convert_cancel",
      requestBody,
      headers,
    );
  }
}

export const swapAPI = new SwapAPI();
